import { FC, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useT } from '../../../../../_metronic/i18n/Metronici18n'
import { Button, useModal } from '../../../../components'
import { NotaVersaoUsuario } from '../core/_models'
import { NotaVersaoCorpo } from './NotaVersaoCorpo'

type Props = {
  nota: NotaVersaoUsuario
  /** Registra a decisão "lida" antes de fechar, para o fechamento não contar como adiamento. */
  onEntendi: () => void
}

/**
 * Corpo do modal da nota vigente. "Ler depois", o X, Esc, o fundo e o link para o histórico só
 * fecham o modal: quem abriu trata o fechamento sem decisão como adiamento.
 */
export const NotaVersaoModalConteudo: FC<Props> = ({ nota, onEntendi }) => {
  const { t } = useT()
  const { closeModal } = useModal()
  const entendiRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    entendiRef.current?.focus()
  }, [])

  const entendi = () => {
    onEntendi()
    closeModal()
  }

  return (
    <div className='d-flex flex-column gap-5'>
      <NotaVersaoCorpo
        versao={nota.versao}
        dtPublicacao={nota.dtPublicacao}
        conteudo={nota.conteudo}
      />
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3'>
        <Link to='/apps/novidades' className='fw-semibold' onClick={closeModal}>
          {t('notas_versao.modal.ver_todas')}
        </Link>
        <div className='d-flex flex-wrap gap-2 ms-auto'>
          <Button variant='secondary-outline' onClick={closeModal}>
            {t('notas_versao.modal.ler_depois')}
          </Button>
          <Button ref={entendiRef} className='btn-primary' onClick={entendi}>
            {t('notas_versao.modal.entendi')}
          </Button>
        </div>
      </div>
    </div>
  )
}
